var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-card",style:({
    width: _vm.iFollowed.duration * _vm.columnWidth + _vm.unityColumnWidth,
    backgroundColor: _vm.iFollowed.color,
  }),attrs:{"id":_vm.iFollowed.details.id},on:{"mouseup":function($event){return _vm.showEvent(_vm.iFollowed)}}},[_c('div',{staticClass:"iconsOptions"},[_c('div',{staticClass:"options"},[_c('v-icon',{staticClass:"v-icon iconCell",style:(_vm.iFollowed.details.advInterventionDto.validated
        ? _vm.iFollowed.details.advInterventionDto.type === 'INTRA'
          ? {
              color: _vm.iFollowed.color,
            }
          : {
              color: '#ffffff',
            }
        : {
            color: _vm.iFollowed.color,
          }),attrs:{"title":_vm.$t('enumIntStatus.interventionSuivie'),"draggable":false}},[_vm._v("\n        mdi-school\n      ")])],1),(_vm.iFollowed.details.advInterventionDto.comment)?_c('div',{staticClass:"redDot",attrs:{"title":_vm.iFollowed.details.advInterventionDto.comment}}):_vm._e()]),_c('p',{style:(_vm.iFollowed.details.advInterventionDto.validated
        ? _vm.iFollowed.details.advInterventionDto.type === 'INTRA'
          ? {
              backgroundColor: '#ffd320',
              color: _vm.iFollowed.color,
              fontWeight: 'bold',
            }
          : {
              background: _vm.iFollowed.color,
              color: '#ffffff',
              fontWeight: 'bold',
            }
        : {
            background: '#FFFFCC',
            color: _vm.iFollowed.color,
            fontWeight: 'bold',
          }),attrs:{"title":_vm.iFollowed.course}},[_vm._v("\n    "+_vm._s(_vm.iFollowed.course)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }